import { PAYMENT_METHOD } from '../constants/orderOption'

export const CUSTOMER_BORNE_PAYMENT_FEE_TEXT = '手数料お客様負担'

export function isCustomerBornePaymentFee (payment) {
    const name = typeof payment === 'string' ? payment : payment && payment.name
    return name === PAYMENT_METHOD.POSTAL_TRANSFER_SLIP || name === PAYMENT_METHOD.BANK_TRANSFER
}



// WEBPACK FOOTER //
// ./src/helpers/payment.js